/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { CreateAppointmentApiArg, CreateAppointmentData } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    createAppointment: build.mutation<CreateAppointmentData, CreateAppointmentApiArg>({
      query: (queryArg) => ({
        body: queryArg.body,
        method: 'POST',
        url: `/v1/appointments`,
      }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as createAppointmentApi };
export const { useCreateAppointmentMutation } = injectedRtkApi;
